import { createContext, useContext } from 'react';
import { GroupSelectionHookResult } from 'utils/hooks/useGroupSelection';
import noop from 'utils/noop';
import { DeleteDataByViewId } from '../types';

type SelectionContextState = GroupSelectionHookResult & {
  deleteDataByViewId: DeleteDataByViewId;
  setDeleteDataByViewId: (deleteData: DeleteDataByViewId) => void;
};

export const defaultSelectionState = {
  selected: [],
  toggleSelection: noop,
  deselectAll: noop,
  selectByIds: noop,
  deleteDataByViewId: {},
  setDeleteDataByViewId: noop,
};

export const SelectionContext = createContext<SelectionContextState>(defaultSelectionState);
export const useSelectionContext = () => useContext(SelectionContext);
